import React from 'react';
import {useFlags} from 'launchdarkly-react-client-sdk';

export function EditCampaignLink({campaignId, children, ...rest}) {
    const featureFlags = useFlags();

    const {isGen3OrderFormEnabled = false} = featureFlags;

    const href = isGen3OrderFormEnabled
        ? `/client/order-form/requirements?campaignId=${campaignId}`
        : `/brands/campaigns/flow/${campaignId}/setup`;

    return (
        <a {...rest} href={href}>
            {children}
        </a>
    );
}



// WEBPACK FOOTER //
// ./edit_campaign_link.js